import axios from "axios";
import firebase from "@/firebase";
const auth = firebase.auth();
import store from "@/store";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  async config => {
    // Get user token before request is sent
    let userToken = await auth.currentUser.getIdToken(/* forceRefresh */ true);

    // Set the authorization header
    config.headers = { Authorization: `Bearer ${userToken}` };

    // Get the server connection
    const serverConnection = store.state.websiteVariables.serverConnection;

    // Set the connection to the config
    config.baseURL = serverConnection;

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default axiosInstance;
